import React, { useEffect } from 'react';

const NoRubberBand = ({ children }) => {
  useEffect(() => {
    const preventDefault = (event) => {
      const target = event.target;
      const top = target.scrollTop;
      const totalScroll = target.scrollHeight;
      const currentScroll = top + target.offsetHeight;

      if (top === 0) {
        event.preventDefault();
      } else if (currentScroll === totalScroll) {
        event.preventDefault();
      }
    };

    document.addEventListener('touchmove', preventDefault, { passive: false });

    return () => {
      document.removeEventListener('touchmove', preventDefault);
    };
  }, []);

  return <div>{children}</div>;
};

export default NoRubberBand;
